import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import { AuthProvider } from "./admin/AuthContext";
import RequireAuth from "./admin/RequireAuth";
import Login from "./admin/Login";
import AdminLayout from "./admin/AdminLayout";

import Topbar from './scenes/global/topbar';
import Footer from './scenes/global/footer';

import Home from './scenes/home';
import About from './scenes/about';
import Solutions from './scenes/solutions';
import Districts from './scenes/districts';
import Testimonials from './scenes/testimonials';
import Careers from './scenes/careers';
import Contact from './scenes/contact';
import Aios from './scenes/aios';
import Gallery from "./scenes/gallery";
import GalleryDetail from "./scenes/gallery/GalleryDetail";
import WhitePapers from "./scenes/whitepapers";

function App() {
    const isAdmin = useLocation().pathname.startsWith('/admin');

    if (isAdmin) {
        // Admin SPA renders chrome-free (no public Topbar/Footer), under a single AuthProvider.
        return (
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AuthProvider>
                    <Routes>
                        <Route path="/admin/login" element={<Login />} />
                        <Route path="/admin/*" element={<RequireAuth><AdminLayout /></RequireAuth>} />
                    </Routes>
                </AuthProvider>
            </ThemeProvider>
        );
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                {/* Top navigation bar on every page */}
                <Topbar />

                {/* Main content area */}
                <Box component="main" sx={{ flex: 1, p: 3, bgcolor: 'background.default' }}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/aios" element={<Aios />} />
                        <Route path="/districts" element={<Districts />} />
                        <Route path="/white-papers" element={<WhitePapers />} />
                        <Route path="/testimonials" element={<Testimonials />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/labs" element={<Navigate to="/aios" replace />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/gallery/:slug" element={<GalleryDetail />} />
                    </Routes>
                </Box>

                {/* Footer on every page */}
                <Footer />
            </Box>
        </ThemeProvider>
    );
}

export default App;
